import React, { useContext, useEffect, useMemo, useState } from "react";

import {
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import {
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsOrderField,
  DeleteItemDetailsResult,
  DeleteItemDetailsVar,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
  ItemDetailsQueryType,
} from "../../masters/items/queries/types";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";

import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import {
  DEFAULT_TIME,
  emptyFunc,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import SiteSelect from "../../../../../customComponents/SiteSelect";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetItemsDetails } from "../../masters/items/queries/queries";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import useLabels from "../../../../../customHooks/useLabels";
import {
  CustomModal,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { Button } from "../../../../../stories/Button/Button";
import { StockEntryTable } from "../../purchase/stockentry/Add/Add";
import Input from "../../../../../stories/Input/Input";
import { useNavigate } from "react-router-dom";
import {
  empType,
  Operation,
  PageFor,
  PageFrom,
} from "../../../../../utils/Enum.types";
import CompaniesAutocomplete from "../../../customer/companies/CompaniesAutocomplete";
import { Title } from "../../../../../stories/Title/Title";
import ArrowRight from "../../../../../images/ArrowRight.svg";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import SuppliersAutocomplete from "../../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { responseType } from "../../../../../utils/formTypes";
import { LdgrQueryType } from "../../masters/supplier/queries/types";
import { TableType } from "../../../customer/companies/queries/types";
import Loading from "../../../../../images/Loading.gif";
import Choose from "../../../../../images/Assign.svg";
import { itmDetailsType } from "../../purchase/material/statesProvider/materialContext";
import {
  emptyModal,
  modalType,
} from "../../masters/grouping/asset/AssociateGroupItemsDetails";
import MessageModal from "../../../../../customComponents/MessageModal";
import Modal from "react-modal";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { msgType } from "../../../../../utils/types";
import LoadingModal from "../../../../pages/LoadingModal";
import AddJunctions from "../../masters/subsidary/junctions/AddJunction";
import {
  AddModalStyles,
  ViewAssetStyles,
} from "../../../../../styles/CustomModalStyles";
import { modalOpertaionFlag } from "../../../customer/Index";
import AddItemDetails from "../../masters/subsidary/junctions/itemdetails/AddItemDetails";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { DeleteItemDetails } from "../../masters/items/queries/mutations";
import { Checkbox } from "@mui/material";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import MoveItemDetailsList from "./MoveItemDetailsList";

export enum ItemDetailsTableFor {
  ASSET_WISE = "Asset wise",
  VENDOR_WISE = "Vendor wise",
  GROUPING = "Grouping",
}
interface Props {
  pageType: ItemDetailsTableFor;
  type: PageFor;
  setModalFlag?: React.Dispatch<React.SetStateAction<modalType>>;
  selectItemDetailsFromModalList?: (
    items: itmDetailsType[],
    itmQty: number,
    index: number
  ) => void;
  selectedItems?: itmDetailsType[];
  itmQty?: number;
  index?: number;
  pageFrom?: PageFrom;
}

export interface selectedMoveItem {
  id: number;
  itemDetailId: number;
  serial_no: string;
}

const Table = ({
  pageType,
  type,
  setModalFlag,
  itmQty,
  selectItemDetailsFromModalList,
  selectedItems,
  index,
  pageFrom,
}: Props) => {
  const { state, dispatch } = useContext(AppContext);
  const [searchData, setSearchData] = useState("");
  const navigate = useNavigate();

  const [loadingState, setLoadingState] = useState(true);
  const [moveto, setMoveto] = useState(false);
  const [messageModal, setMessageModal] = useState<msgType>(emptyMessage);
  const [tempSelectedIds, setTempSelectedIds] = useState<itmDetailsType[]>([]);
  const [selectedMoveItems, setSelectedMoveItems] = useState<
    selectedMoveItem[]
  >([]);
  const [associate, setAssociate] = useState(false);

  const [checkIds, setCheckIds] = useState<number[]>([]);
  const [stateChanged, setStateChanged] = useState(false);
  const { user_details } = useLoggedInUserDetails();
  const {
    customer_id,
    company_id,
    sub_id,
    siteID,
    junctionID,
    item_id,
    supplier_id,
  } = useUrlParams();
  const {
    companyLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    junctionLabel,
    ledgerLabel,
  } = useLabels();
  const [selectedSupplier, setSelectedSupplier] = useState<responseType | null>(
    null
  );

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setItems] = useState<AtsStckItemDetailsEdges[]>([]);
  const [addModal, setAddModal] = useState<modalOpertaionFlag>({
    operation: Operation.CREATE,
    flag: false,
  });
  const [deleteModal, setDeleteModal] = useState(false);

  const [GetDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetails);

  const [DeleteDetails, { loading: deleteLoading }] = useMutation<
    DeleteItemDetailsResult,
    DeleteItemDetailsVar
  >(DeleteItemDetails, {
    onError: (e) => {
      setMessageModal({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id || company_id) {
          await GetDetails({
            variables: {
              customerID: customer_id ? customer_id : 0,
              companyID: company_id
                ? company_id
                : state.companyId
                ? state.companyId
                : 0,
              subsidiaryID: sub_id
                ? sub_id
                : state.subsidiaryId
                ? state.subsidiaryId
                : 0,
              junctionID: junctionID
                ? junctionID
                : state.junctionID
                ? state.junctionID
                : 0,
              siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
              input: {
                query_type: ItemDetailsQueryType.DETAILS_BY_ITEM_ID,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                itemID: state.itmId ? state.itmId : item_id ? item_id : 0,
                ldgrID: supplier_id
                  ? supplier_id
                  : selectedSupplier
                  ? selectedSupplier.value
                  : 0,
                poleNum: 0,
                empID: user_details.id!,
              },
              after: null,
              first: ROWS_PER_PAGE,
              name: searchData,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemDetailsOrderField.CREATED_AT,
              },
            },
          });
          setLoadingState(false);
        }
      } catch (err) {
        setLoadingState(false);
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [
    customer_id,
    sub_id,
    GetDetails,
    searchData,
    state.itmId,
    state.companyId,
    state.subsidiaryId,
    state.junctionID,
    state.subSiteId,
    item_id,
    selectedSupplier,
  ]);

  const handleCheckboxChange = (
    itm: itmDetailsType,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = (e.target as HTMLInputElement).checked;

    if (checked) {
      setTempSelectedIds([...tempSelectedIds, itm]);
      setCheckIds([...checkIds, itm.value]);
    } else {
      setTempSelectedIds(
        tempSelectedIds.filter(({ value }) => value !== itm.value)
      );
      setCheckIds(checkIds.filter((t) => t !== itm.value));
    }
    setStateChanged(!stateChanged);
  };

  const handleSelect = (item: selectedMoveItem) => {
    setSelectedMoveItems((prev) => {
      const exists = prev.some(
        (selected) => selected.itemDetailId === item.itemDetailId
      );
      if (exists) {
        // remove item
        return prev.filter(
          (selected) => selected.itemDetailId !== item.itemDetailId
        );
      } else {
        // add item
        return [...prev, item];
      }
    });
  };
  // const dynamicHeaders: TableHeaderProps[] = Reports.AssetDetails.map((header) => ({
  //   headerName: header.headerName,
  //   field: header.field,
  //   headerAlign: header.headerAlign as GridAlignment,
  //   align: header.align as GridAlignment,
  //   flex: header.flex,
  //   hideable: header.hideable,
  //   cellClassName: header.cellClassName
  // }));

  const columns: GridColDef[] = [
    {
      headerName: "Sl",
      field: StockEntryTable.SL_No,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      // flex: FlexForColumns.SLNO,
      cellClassName: "number-cell",
      // renderCell: (params: any) => {
      //   const isSelected = checkIds.includes(params.row.itemDetailId);

      //   const itm: itmDetailsType = {
      //     itemName: "",
      //     label: params.row.serial_no,
      //     value: params.row.itemDetailId,
      //     poleNum: 0,
      //   };

      //   return (
      //     <>
      //       {params.value}{" "}
      //       <Checkbox
      //         checked={isSelected}
      //         onChange={(e) => {
      //           if (itmQty && tempSelectedIds.length + 1 <= itmQty)
      //             handleCheckboxChange(itm, e);
      //           else {
      //             setMessageModal({
      //               flag: true,
      //               message: `Cannot select more that ${itmQty}`,
      //               operation: Operation.NONE,
      //             });
      //           }
      //         }}
      //       />
      //     </>
      //   );
      // },
      renderCell: (params: any) => {
        const isSelected = selectedMoveItems.some(
          (s) => s.itemDetailId === params.row.itemDetailId
        );

        const item: selectedMoveItem = {
          id: params.row.id,
          itemDetailId: params.row.itemDetailId,
          serial_no: params.row.serial_no,
        };

        return (
          <>
            {moveto ? (
              <Checkbox
                checked={isSelected}
                onChange={(e) => {
                  handleSelect(item);
                }}
              />
            ) : (
              params.value
            )}
          </>
        );
      },
    },

    ...(items && items.length && items[0].node.item.trackSerial
      ? [
          {
            headerName: "Serial No.",
            field: StockEntryTable.Serial_No,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
            hideable: false,
          },
        ]
      : []),

    {
      headerName: `${companyLabel}`,
      field: `${companyLabel}`,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell",
    },
    {
      headerName: `${subsidiaryLabel}`,
      field: subsidiaryLabel,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell",
    },
    {
      headerName: `${subsidiarySiteLabel}`,
      field: subsidiarySiteLabel,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell",
    },

    {
      headerName: `Maintained By`,
      field: "maintainedBy",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell",
    },
    {
      headerName: `Address`,
      field: "address",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell",
    },
    ...(items && items.length && items[0].node.item.trackAmc
      ? [
          {
            headerName: "AMC Start Date",
            field: StockEntryTable.AMC_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
          {
            headerName: "AMC End Date",
            field: StockEntryTable.AMC_End_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackBrand
      ? [
          {
            headerName: "Brand",
            field: StockEntryTable.Brand,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackModel
      ? [
          {
            headerName: "Model",
            field: StockEntryTable.Model,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackBatch
      ? [
          {
            headerName: "Batch.",
            field: StockEntryTable.Batch,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackExpiry
      ? [
          {
            headerName: "Expiry",
            field: StockEntryTable.Expiry,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackWarranty
      ? [
          {
            headerName: "Warranty Start Date",
            field: StockEntryTable.Warranty_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },

          {
            headerName: "Warranty End Date",
            field: StockEntryTable.Warranty_End_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackMaintenance
      ? [
          {
            headerName: "Maintained By",
            field: StockEntryTable.Maintained_By,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackGeoLocation
      ? [
          {
            headerName: "Geo Location",
            field: StockEntryTable.Geo_Location,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
          },
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackInsurance
      ? [
          {
            headerName: "Insurance Start Date.",
            field: StockEntryTable.INC_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
          {
            headerName: "Insurance End Date.",
            field: StockEntryTable.INC_end_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell",
          },
        ]
      : []),

    {
      headerName: "Stock Location",
      field: StockEntryTable.Stock_Location,
      headerAlign: HEADER_TEXT_ALIGN,
      flex: FlexForColumns.DESCRIPTION,
    },
    ...(pageFrom === PageFrom.SITE || pageFrom === PageFrom.ADDSITE
      ? [
          {
            headerName: "Action",
            field: "Action",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SLNO,
            cellClassName: "number-cell",
            renderCell: (params: any) => {
              return (
                <>
                  <img
                    src={Edit}
                    alt=""
                    onClick={() => {
                      dispatch({
                        type: payloadTypes.SET_ITEM_DETAILS_ID,
                        payload: {
                          itemDetailsId: params.row.itemDetailId,
                        },
                      });

                      setAddModal({
                        operation: Operation.UPDATE,
                        flag: true,
                      });
                    }}
                  />
                  <img
                    src={Delete}
                    alt=""
                    onClick={() => {
                      dispatch({
                        type: payloadTypes.SET_ITEM_DETAILS_ID,
                        payload: {
                          itemDetailsId: params.row.itemDetailId,
                        },
                      });

                      setDeleteModal(true);
                    }}
                  />
                </>
              );
            },
          },
        ]
      : []),
  ];

  const rows: GridValidRowModel[] = useMemo(() => {
    return items.map(({ node: data }, index) => {
      return {
        id: index + 1,
        serial_no: data.prodSerialNo,
        batch: data.prodBatchNo,
        expiry:
          toStandardDate(data.prodExpiryDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodExpiryDate),
        brand: data.prodBrand,
        model: data.prodModel,
        warranty_start_date:
          toStandardDate(data.prodWarrantyStartDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodWarrantyStartDate),
        warranty_end_date:
          toStandardDate(data.prodWarrantyEndDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodWarrantyEndDate),
        amc_start_date:
          toStandardDate(data.prodAmcStDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodAmcStDate),

        amc_end_date:
          toStandardDate(data.prodAmcEndDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodAmcEndDate),

        geo_location: "",
        inc_start_date:
          toStandardDate(data.prodInsuranceStDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodInsuranceStDate),

        inc_end_date:
          toStandardDate(data.prodInsuranceEndDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodInsuranceEndDate),

        stock_location: "",
        [`${companyLabel}`]: data.currentCompany.name,
        [`${subsidiaryLabel}`]: data.currentSubsidiary.name,
        [`${subsidiarySiteLabel}`]: data.currentSite.name,
        [`${junctionLabel}`]: data.currentJunction.name,
        poleNum: data.poleNum,
        maintainedBy: data.vendorDetails.desc,
        itemDetailId: data.id,
        address: data.address,
      };
    });
  }, [items]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItemsDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
      setHasNextPage(data.GetItemsDetails.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [data, loading]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetItemsDetails.edges;
          const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetItemsDetails.edges.filter(
            ({ node: { id } }) =>
              newEdges.findIndex(({ node: { id: newId } }) => newId === id) !==
              -1
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetItemsDetails: {
              edges: [...items, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetItemsDetails.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      serial_no: true,
      companyLabel: false,
      subsidiaryLabel: false,
      subsidiarySiteLabel: false,
      junctionLabel: true,
      amc_start_date: true,
      amc_end_date: false,
      batch: false,
      expiry: false,
      brand: true,
      model: true,
      warranty_start_date: false,
      warranty_end_date: false,
      geo_location: false,
      inc_start_date: false,
      inc_end_date: false,
      stock_location: false,
      poleNum: true,
      maintainedBy: false,
      actions: true,
    });

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS,
      JSON.stringify(newModel)
    );
  };

  const clearFilters = () => {
    dispatch({
      type: payloadTypes.SET_COMPANY_ID,
      payload: {
        companyId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_ID,
      payload: {
        subsidiaryId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_SITE_ID,
      payload: {
        subSiteId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_JUNCTION_ID,
      payload: {
        junctionID: 0,
      },
    });
    setSearchData("");
  };
  useEffect(() => {
    clearFilters();
  }, []);
  const { itemLabel } = useLabels();
  const dashboardNavbar =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;
  useEffect(() => {
    if (selectedItems) {
      setTempSelectedIds(selectedItems);
    }
  }, []);

  const handleDelete = () => {
    if (state.itemDetailsId && customer_id) {
      setDeleteModal(false);
      DeleteDetails({
        variables: {
          customerID: customer_id,
          itemDetailsID: state.itemDetailsId,
          user_details: user_details,
        },
        refetchQueries: [
          {
            query: GetItemsDetails,
            variables: {
              customerID: customer_id ? customer_id : 0,
              companyID: company_id
                ? company_id
                : state.companyId
                ? state.companyId
                : 0,
              subsidiaryID: sub_id
                ? sub_id
                : state.subsidiaryId
                ? state.subsidiaryId
                : 0,
              junctionID: junctionID
                ? junctionID
                : state.junctionID
                ? state.junctionID
                : 0,
              siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
              input: {
                query_type: ItemDetailsQueryType.DETAILS_BY_ITEM_ID,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                itemID: state.itmId ? state.itmId : item_id ? item_id : 0,
                ldgrID: supplier_id
                  ? supplier_id
                  : selectedSupplier
                  ? selectedSupplier.value
                  : 0,
                poleNum: 0,
                empID: user_details.id!,
              },
              after: null,
              first: ROWS_PER_PAGE,
              name: searchData,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemDetailsOrderField.CREATED_AT,
              },
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.DeleteItemDetails) {
          setMessageModal({
            flag: true,
            message: "Deleted item details successfully",
            operation: Operation.DELETE,
          });
        }
      });
    }
  };

  const handleClose = () => {
    setMessageModal(emptyMessage);
    dispatch({
      type: payloadTypes.SET_ITEM_DETAILS_ID,
      payload: {
        itemDetailsId: 0,
      },
    });
  };

  return (
    <>
      <div className="asset-reports__right--block">
        {pageType === ItemDetailsTableFor.VENDOR_WISE && (
          <div className="asset-reports__right--block--flex">
            <button
              className="asset-reports__right--block--button"
              onClick={() => {
                clearFilters();
                if (dashboardNavbar)
                  navigate(`/${customer_id}/reports/vendorwise`);
                else
                  navigate(
                    `/${customer_id}/company/${company_id}/reports/vendorwise/${supplier_id}`
                  );
              }}
            >
              <img src={ArrowRight} alt="" />
              Back
            </button>
            <Title variant="subtitle1">
              <b>{items[0]?.node.item.desc}</b>
            </Title>
          </div>
        )}
        {type === PageFor.MODAL && <Title>{`${itemLabel} Details`}</Title>}
        <div className="asset-reports__right--filters row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />{" "}
          </div>
          {!company_id ? (
            <div className="col-2">
              <CompaniesAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                label={companyLabel}
                value={state.companyId ? state.companyId : 0}
              />
            </div>
          ) : null}

          {!sub_id ? (
            <div className="col-2">
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                label={subsidiaryLabel}
                companyID={
                  company_id
                    ? company_id
                    : state.companyId
                    ? state.companyId
                    : 0
                }
                onKeyDown={emptyFunc}
                value={state.subsidiaryId ? state.subsidiaryId : 0}
              />
            </div>
          ) : null}
          {!siteID ? (
            <div className="col-2">
              <SiteSelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                companyId={
                  company_id
                    ? company_id
                    : state.companyId
                    ? state.companyId
                    : 0
                }
                subsidiaryId={
                  sub_id ? sub_id : state.subsidiaryId ? state.subsidiaryId : 0
                }
                onKeyDown={emptyFunc}
                value={state.subSiteId ? state.subSiteId : 0}
                label={subsidiarySiteLabel}
              />
            </div>
          ) : null}
          {/* {!junctionID ? (
          <div className="col-2">
            <JunctionsAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_JUNCTION_ID,
                    payload: {
                      junctionID: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_JUNCTION_ID,
                    payload: {
                      junctionID: 0,
                    },
                  });
                }
              }}
              companyID={
                company_id ? company_id : state.companyId ? state.companyId : 0
              }
              subsidiaryID={
                sub_id ? sub_id : state.subsidiaryId ? state.subsidiaryId : 0
              }
              siteID={state.subSiteId ? state.subSiteId : 0}
              onKeyDown={emptyFunc}
              value={state.junctionID ? state.junctionID : 0}
              label={junctionLabel}
            />
          </div>
        ) : null} */}
          <div className="col-2">
            <SuppliersAutocomplete
              onChange={(newValue) => {
                if (newValue) setSelectedSupplier(newValue);
                else setSelectedSupplier(null);
              }}
              onKeyDown={emptyFunc}
              label={ledgerLabel}
              value={selectedSupplier ? selectedSupplier.value : 0}
              input={{
                itemID: state.itmId ? state.itmId : item_id ? item_id : 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: TableType.ASSET,
              }}
            />
          </div>
        </div>
        <div
          className={`asset-reports__right--tableblock${
            pageType === ItemDetailsTableFor.VENDOR_WISE ||
            type === PageFor.MODAL
              ? "--vendor-items"
              : ""
          }`}
        >
          {loadingState ? (
            <div className="loading-container">
              <img src={Loading} className="loading-gif" />
            </div>
          ) : (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
              onRowsScrollEnd={() => {
                if (data) {
                  handleScroll();
                }
              }}
            />
          )}
        </div>
        <div className="asset-reports__right--block--footer">
          <div>
            {pageType === ItemDetailsTableFor.GROUPING ? null : pageFrom ===
              PageFrom.REPORTS ? (
              <Button mode="excel">Excel</Button>
            ) : null}
            {type === PageFor.GENERAL ? (
              <>
                {pageFrom === PageFrom.SITE ? (
                  moveto ? (
                    <>
                      <Button
                        mode="move-to"
                        onClick={() => {
                          setAssociate(true);
                        }}
                      />

                      <Button
                        onClick={() => {
                          setSelectedMoveItems([]);
                        }}
                        mode="clear"
                      />
                    </>
                  ) : (
                    <Button
                      onClick={() => {
                        setMoveto(true);
                      }}
                    >
                      Transfer
                    </Button>
                  )
                ) : null}

                <Button mode="back" onClick={() => navigate(-1)} />
              </>
            ) : (
              <>
                <Button
                  mode="choose"
                  onClick={() => {
                    if (selectItemDetailsFromModalList && itmQty) {
                      selectItemDetailsFromModalList(
                        tempSelectedIds,
                        itmQty,
                        index ? index : 0
                      );
                    }
                    // if (setModalFlag) setModalFlag(emptyModal);
                  }}
                />
                <Button
                  mode="cancel"
                  onClick={() => {
                    setModalFlag?.({
                      flag: false,
                      qty: -1,
                    });
                  }}
                />
              </>
            )}
          </div>
          <div className="overall-total-count">
            Total Count : <b>{data?.GetItemsDetails.totalCount}</b>
          </div>
        </div>
      </div>

      <Modal isOpen={addModal.flag} style={AddModalStyles} ariaHideApp={false}>
        <AddItemDetails
          setModalFlag={setAddModal}
          operation={addModal.operation}
        />
      </Modal>

      <CustomDrawer
        anchor="right"
        open={associate}
        onClose={() => setAssociate(!associate)}
      >
        <MoveItemDetailsList
          selectedMoveItems={selectedMoveItems}
          setModalFlag={setAssociate}
          setSelectedMoveItems={setSelectedMoveItems}
        />
      </CustomDrawer>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />

      <MessageModal
        handleClose={handleClose}
        modalFlag={messageModal.flag}
        operation={messageModal.operation}
        value={messageModal.message}
      />
      <LoadingModal flag={(!searchData && loading) || deleteLoading} />
    </>
  );
};

export default Table;
